/**
 * Visual Blocks Editor
 *
 * Copyright 2014 Massachusetts Institute of Technology
 * http://zerorobotics.org/
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * @fileoverview Generating C++ for basic ZR API blocks.
 * @author dininno@mit.edu (Ethan DiNinno)
 *
 * Converted from the legacy Zero Robotics Blockly generator
 * to the modern STEMX365 zrCppGenerator.
 */

import { zrCppGenerator } from "./zrCppGenerator";


// ============================================================
// Generic generator for void functions with one argument
// ============================================================

zrCppGenerator.forBlock["proto_oneArgumentNoReturn"] =
    function(block) {

        const func =
            block.getFieldValue("FUNCTION");

        const arg =
            this.valueToCode(
                block,
                "ARGUMENT",
                this.ORDER_NONE
            );

        const code =
            func +
            "(" +
            arg +
            ");\n";

        return code;
    };


// ============================================================
// SPHERES API blocks
// ============================================================

zrCppGenerator.forBlock["spheres_setTarget"] =
    zrCppGenerator.forBlock["proto_oneArgumentNoReturn"];

zrCppGenerator.forBlock["spheres_getZRState"] =
    zrCppGenerator.forBlock["proto_oneArgumentNoReturn"];


zrCppGenerator.forBlock["spheres_getTime"] =
    function(block) {

        return [
            "api.getTime()",
            this.ORDER_FUNCTION_CALL
        ];
    };


zrCppGenerator.forBlock["spheres_setPos"] =
    function(block) {

        const x =
            this.valueToCode(
                block,
                "X",
                this.ORDER_COMMA
            ) || "0";

        const y =
            this.valueToCode(
                block,
                "Y",
                this.ORDER_COMMA
            ) || "0";

        const z =
            this.valueToCode(
                block,
                "Z",
                this.ORDER_COMMA
            ) || "0";

        const code =
            "setPos(" +
            x +
            ", " +
            y +
            ", " +
            z +
            ");\n";

        return code;
    };


zrCppGenerator.forBlock["spheres_I_am_Blue"] =
    function(block) {

        return [
            "(api.getSatColor()==SPHERE1)",
            this.ORDER_FUNCTION_CALL
        ];
    };


zrCppGenerator.forBlock["spheres_I_am_Red"] =
    function(block) {

        return [
            "(api.getSatColor()==SPHERE2)",
            this.ORDER_FUNCTION_CALL
        ];
    };